import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface NCFileDetailsPartDocumentsProps {
  partId: number | null;
}

const NCFileDetailsPartDocumentsComponent: FC<NCFileDetailsPartDocumentsProps> = ({
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getPartByID,
  getNCFileById,
  partId,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getTools,
    updateHeaderConfig,
    getProductionBatchByNCFile,
    getPartByID,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.part}>
      {partId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={partId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const NCFileDetailsPartDocuments = connect(({ details: { partId } }) => ({ partId }), {
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getPartByID,
  getNCFileById,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsPartDocumentsComponent);

export { NCFileDetailsPartDocuments };
